"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/order/v1/cms_service.proto (package spwn.order.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSOrderService = void 0;
const cms_service_pb_1 = require("./cms_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.order.v1.CMSOrderService
 */
exports.CMSOrderService = {
    typeName: "spwn.order.v1.CMSOrderService",
    methods: {
        /**
         * @generated from rpc spwn.order.v1.CMSOrderService.GetGoodsOrder
         */
        getGoodsOrder: {
            name: "GetGoodsOrder",
            I: cms_service_pb_1.CMSOrderServiceGetGoodsOrderRequest,
            O: cms_service_pb_1.CMSOrderServiceGetGoodsOrderResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.order.v1.CMSOrderService.GetGoodsOrdersByBrandFirestoreId
         */
        getGoodsOrdersByBrandFirestoreId: {
            name: "GetGoodsOrdersByBrandFirestoreId",
            I: cms_service_pb_1.CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdRequest,
            O: cms_service_pb_1.CMSOrderServiceGetGoodsOrdersByBrandFirestoreIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 売上個数を取得するためのメソッド
         *
         * @generated from rpc spwn.order.v1.CMSOrderService.GetGoodsOrdersByGoodsIds
         */
        getGoodsOrdersByGoodsIds: {
            name: "GetGoodsOrdersByGoodsIds",
            I: cms_service_pb_1.CMSOrderServiceGetGoodsOrdersByGoodsIdsRequest,
            O: cms_service_pb_1.CMSOrderServiceGetGoodsOrdersByGoodsIdsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.order.v1.CMSOrderService.UpdateGoodsOrderComment
         */
        updateGoodsOrderComment: {
            name: "UpdateGoodsOrderComment",
            I: cms_service_pb_1.CMSOrderServiceUpdateGoodsOrderCommentRequest,
            O: cms_service_pb_1.CMSOrderServiceUpdateGoodsOrderCommentResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.order.v1.CMSOrderService.CancelGoodsOrder
         */
        cancelGoodsOrder: {
            name: "CancelGoodsOrder",
            I: cms_service_pb_1.CMSOrderServiceCancelGoodsOrderRequest,
            O: cms_service_pb_1.CMSOrderServiceCancelGoodsOrderResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.order.v1.CMSOrderService.GetSalesBreakdownByMonth
         */
        getSalesBreakdownByMonth: {
            name: "GetSalesBreakdownByMonth",
            I: cms_service_pb_1.CMSOrderServiceGetSalesBreakdownByMonthRequest,
            O: cms_service_pb_1.CMSOrderServiceGetSalesBreakdownByMonthResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 口座情報を登録するためのメソッド
         *
         * @generated from rpc spwn.order.v1.CMSOrderService.SaveBankAccount
         */
        saveBankAccount: {
            name: "SaveBankAccount",
            I: cms_service_pb_1.CMSOrderServiceSaveBankAccountRequest,
            O: cms_service_pb_1.CMSOrderServiceSaveBankAccountResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 口座情報を取得するためのメソッド
         *
         * @generated from rpc spwn.order.v1.CMSOrderService.GetBankAccount
         */
        getBankAccount: {
            name: "GetBankAccount",
            I: cms_service_pb_1.CMSOrderServiceGetBankAccountRequest,
            O: cms_service_pb_1.CMSOrderServiceGetBankAccountResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=cms_service_connect.js.map